import React, { useState, useEffect } from 'react';
import { Dropdown } from 'semantic-ui-react'
import ReadAxios from '../axiosComponent/readAxios';
const MyState = ({
    field: { name },
    form: { setFieldValue },
    ...props
}) => {
    const [content, setcontent] = useState([])
    const [loading, setloading] = useState(false)
    useEffect(() => {
        // $("#searchType .dropdown").removeClass("dropdown")
        setloading(true)
        ReadAxios({ masterURL: `${process.env.REACT_APP_MAIN_URL}/masters/stateMaster`, method: "get" })
            .then((result) => {
                setcontent(result.data.resultSet)
                setloading(false)
            })
    }, [])
    // let handleSearch = (e, data) => {
    //     if (data.searchQuery) {
    //         setloading(true)
    //         let searchTerm = data.searchQuery
    //         ReadAxios({ masterURL: `${process.env.REACT_APP_MAIN_URL}/masters/stateMaster`, bodyItems: { searchTerm: searchTerm }, method: "get" })
    //             .then((result) => {
    //                 setcontent(result.data.resultSet)
    //                 setloading(false)
    //             })
    //     }
    // }
    let options = []
    if (content.length > 0) {
        content.map((object, index) => {
            let temp = {}
            temp.key = index + 1
            temp.text = object.state
            temp.value = object.stateId
            return options[index] = temp
        })
    }
    let handleChange = (value, data) => {
        setFieldValue(name, data.value)
        content.filter((item) => {
            if (data.value === item.stateId) {
                props.getStateInfo(item)
                // setdriverContact(item.driverContact)
                // setdriverLic(item.driverLicense)
                // console.log('>>>', item)
            }
        })
    }
    return (
        <Dropdown
            selection
            search
            clearable
            loading={loading ? true : false}
            style={{ width: "50%", fontWeight: "normal" }}
            onChange={handleChange}
            options={options}
            // disabled="true"
            // id="searchType"
            error={props.error}
            // onSearchChange={handleSearch}
            noResultsMessage="Search for Result"
            {...props}
        />
    )
}
export default MyState